import React, { useState } from 'react'
import { Alert, Button, Card, Form } from 'react-bootstrap'
import Title from 'common/components/Title'
import API from 'common/logic/API'

function SqlAdmin() {
    const [query, setQuery] = useState('SELECT 1 AS one')
    const [result, setResult] = useState<string | null>(null)
    const [error, setError] = useState<string | null>(null)
    const [running, setRunning] = useState(false)

    const runQuery = () => {
        setRunning(true)
        setError(null)
        setResult(null)

        API.post('/admin/sql', { query })
            .then((response: any) => {
                setResult(String(response.data))
            })
            .catch((err: any) => {
                const responseData = err?.response?.data
                setError(responseData?.message || responseData || err.message || 'SQL execution failed')
            })
            .finally(() => {
                setRunning(false)
            })
    }

    return <>
        <Title title="SQL" />
        <Alert variant="warning">
            Dangerous admin-only tool. Be careful: the query runs directly against the database.
        </Alert>

        <Form.Group controlId="sql-query">
            <Form.Label>SQL query</Form.Label>
            <Form.Control
                as="textarea"
                rows={10}
                value={query}
                onChange={(event) => setQuery(event.target.value)}
                spellCheck={false}
            />
        </Form.Group>
        <Button type="button" onClick={runQuery} disabled={running}>
            {running ? 'Running...' : 'Run'}
        </Button>

        {error && <Alert className="mt-3" variant="danger">{error}</Alert>}
        {result !== null && (
            <Card className="mt-3">
                <Card.Body>
                    <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{result}</pre>
                </Card.Body>
            </Card>
        )}
    </>
}

export default SqlAdmin
